import fetch from '@/utils/fetch'
import {wymsFetch} from '@/utils/fetch'

/**
 * 统一处理请求参数
 * */
function filterURLSearchParams(args = {}) {
  const params = new URLSearchParams();
  Object.keys(args).forEach(key => {
    params.append(key, args[key])
  });
  return params
}

/**
 * 应用接入列表
 * */
export function querySuiteList(args) {
  return wymsFetch({
    url: 'suiteAccess/querySuiteList',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 套件
 * */
/**
 * 套件列表页
 * */
export function getSuiteList(args) {
  return wymsFetch({
    url: 'suite/list',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 套件详情
 * */
export function getSuiteInfo(args) {
  return wymsFetch({
    url: 'suite/detail',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 套件删除
 * */
export function deleteSuite(args) {
  return wymsFetch({
    url: 'suite/deleteSuite',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 新增套件
 * */
export function addSuite(args) {
  return wymsFetch({
    url: 'suite/addSuite',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 编辑套件
 * */
export function updateSuite(args) {
  return wymsFetch({
    url: 'suite/updateSuite',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 套件安装
 * */
export function suiteInstall(args) {
  return wymsFetch({
    url: 'suite/install',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 套件应用
 * */
/**
 * 套件可配置应用列表
 * */
export function showModuleList(args) {
  return wymsFetch({
    url: 'suiteModule/showModuleList',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 新增套件应用
 * */
export function addSuiteModule(args) {
  return wymsFetch({
    url: 'suiteModule/addSuiteModule',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 套件角色
 * */
/**
 * 展示套件可配置角色列表
 * */
export function showRoleList(args) {
  return wymsFetch({
    url: 'suiteRole/showRoleList',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 新增套件角色
 * */
export function addSuiteRole(args) {
  return wymsFetch({
    url: 'suiteRole/addSuiteRole',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}



// WEBPACK FOOTER //
// ./src/api/suiteSystem.js